export const MODAL_RESET_TIMEOUT_MS = 10000;
